import moment from 'moment-timezone'
import { CalendarEventType, EventCalendar } from '@/types/Calendar'
import { TaskNote, TaskNoteType } from '@/types/TaskNote.ts'

export function dataTaskNotes(taskNotes: TaskNote[]): EventCalendar[] {
    return taskNotes
        .filter(
            (taskNote: TaskNote): boolean =>
                taskNote.type === TaskNoteType.task ||
                taskNote.type === TaskNoteType.appointmentInPerson ||
                taskNote.type === TaskNoteType.appointmentVideoconference
        )
        .map((taskNote: TaskNote): EventCalendar => {
            const start: string = taskNote.startHour ? moment(taskNote.startHour, 'HH:mm:ss').format('HH:mm') : '00:00'
            const end: string = taskNote.endHour
                ? moment(taskNote.endHour, 'HH:mm:ss').format('HH:mm')
                : taskNote.startHour
                  ? start
                  : '23:59'

            return {
                title: `${start !== '00:00' ? start + ' ' : ''}${end !== '23:59' && end !== start ? '- ' + end : ''} - ${taskNote.title}`,
                start: moment(
                    moment(taskNote.date, 'DD-MM-YYYY').format('YYYY-MM-DD') + ' ' + start,
                    'YYYY-MM-DD HH:mm'
                ).toDate(),
                end: moment(
                    moment(taskNote.date, 'DD-MM-YYYY').format('YYYY-MM-DD') + ' ' + end,
                    'YYYY-MM-DD HH:mm'
                ).toDate(),
                number: '',
                type: CalendarEventType.TASK_NOTE,
                slots: taskNote
            }
        })
}
